
export default {
    inheritAttrs: false,

    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: null,

        size: {
            type: Number,
            default: 1,
        },

        boxSize: {
            type: String,
            default: 'h-5 w-5',
        },
        textClass: {
            type: String,
            default: 'text-sm text-general-5 text-opacity-50 font-semibold',
        },
        model: undefined,
    },

    computed: {
        isChecked() {
            if (this.model && Array.isArray(this.value)) {
                const idx = this.value.findIndex((el) => JSON.stringify(el) === JSON.stringify(this.model))
                return idx > -1
            } else return this.value
        },
    },

    methods: {
        onChange(event) {
            if (this.model && Array.isArray(this.value)) {
                const value = JSON.parse(JSON.stringify(this.value))
                const idx = value.findIndex((el) => JSON.stringify(el) === JSON.stringify(this.model))
                if (idx > -1) value.splice(idx, 1)
                else value.push(this.model)
                this.$emit('input', value)
            } else this.$emit('input', event.target.checked)
        },
    },
}
